import React from "react";
import styled, { keyframes } from "styled-components";

const ITEMS = [
  "改善",
  "Kaizen",
  "Opsednuti ciljevima",
  "改善",
  "1% bolje svaki dan",
];

const isKanji = (t) => /[一-鿿]/.test(t);

// Traka se animira translateX(-50%), pa mora imati dve identicne polovine,
// a svaka polovina mora biti sira od ekrana da ne bi ostala praznina.
const HALF = [...ITEMS, ...ITEMS, ...ITEMS];

const Marquee = () => (
  <Wrap>
    <Track>
      {[...HALF, ...HALF].map((item, i) => (
        <React.Fragment key={i}>
          <Item $kanji={isKanji(item)}>{item}</Item>
          <Dot>◆</Dot>
        </React.Fragment>
      ))}
    </Track>
  </Wrap>
);

export default Marquee;

const scroll = keyframes`
  to { transform: translateX(-50%); }
`;

const Wrap = styled.div`
  width: 100%;
  overflow: hidden;
  border-bottom: 1px solid var(--line, rgba(255, 255, 255, 0.07));
  padding: 1.6rem 0;
  background: var(--bg0, #0a0a0c);

  &:hover > div {
    animation-play-state: paused;
  }
`;

const Track = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  animation: ${scroll} 96s linear infinite;
`;

const Item = styled.span`
  font-family: ${(props) =>
    props.$kanji ? "var(--font-kanji)" : '"Anton", sans-serif'};
  text-transform: uppercase;
  font-size: clamp(1.6rem, 2.6vw, 2.4rem);
  line-height: 1;
  letter-spacing: 0.06em;
  padding: 0 2.2rem;
  white-space: nowrap;
  color: ${(props) =>
    props.$kanji ? "var(--red, #fe5f55)" : "var(--text, #f4f2ee)"};
`;

const Dot = styled.span`
  color: var(--red, #fe5f55);
  font-size: 0.9rem;
  line-height: 1;
  user-select: none;
`;
